import { DateTimeField, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FilterAccordionBody, FilterAccordionItem } from "./AccordionFilterItemStyles";

interface Props {
	name: string;
}

export const AccordionItemStart: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }] = useField<string | null>(name);

	return (
		<FilterAccordionItem
			title={t("Start")}
			actions={<TextSpan $size="small">{t("GREATER_THAN_EQUAL")}</TextSpan>}
			initialOpen={value !== null}
			body={
				<FilterAccordionBody>
					<DateTimeField name={name} label="" />
				</FilterAccordionBody>
			}
		/>
	);
};
